module.exports = __webpack_public_path__ + "static/media/features-home-element-01.a59dc188.png";